/* import __COLOCATED_TEMPLATE__ from './url.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();